// extracted by mini-css-extract-plugin
module.exports = {"title":"CommonQuestions-module--title--G3o1W","subtitle":"CommonQuestions-module--subtitle--XGXDg","text":"CommonQuestions-module--text--2WIgu"};